export default __webpack_public_path__ + "static/media/clear.28811ab4.svg";